import React, { useState } from 'react';

import styled from 'styled-components';

import NwIcon from './NwIcon';
import NwLink from './NwLink';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const CopyTextContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.25rem 1rem;
    font-size: 90%;
    background: rgba(150, 150, 150, 0.06);
    border: 1px solid rgba(100, 100, 100, 0.2);
    border-bottom-width: 2px;
    border-radius: 3px;
    font-family: ${(props) => props.theme.FontFamilyMonospace};
    width: ${(props) => (props.$fullWidth ? '100%' : 'auto')};
    color: ${(props) => props.theme.TextColor};
    opacity: 1;
    gap: 1rem;

    @media (max-width: 720px) {
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 0;
    }

    .copy-text-container-text {
        p {
            display: block;
            font-family: ${(props) => props.theme.FontFamilyMonospace};
            margin-bottom: 0.25rem;
        }
        small {
            display: block;
        }
    }
`;

const NwClipboardCopyText = ({ text, label, asLink, fullWidth = true }) => {
    const [isCopied, setIsCopied] = useState(false);

    const copyTextToClipboard = async (text) => {
        try {
            if ('clipboard' in navigator) {
                await navigator.clipboard.writeText(text);
                return true;
            } else {
                alert('Clipboard API not supported in this browser');
                return false;
            }
        } catch (err) {
            console.error('Failed to copy text: ', err);
            return false;
        }
    };

    // onClick handler function for the copy button
    const handleCopyClick = () => {
        // Asynchronously call copyTextToClipboard
        copyTextToClipboard(text)
            .then(() => {
                // If successful, update the isCopied state value
                setIsCopied(true);
                setTimeout(() => {
                    setIsCopied(false);
                }, 3500);
            })
            .catch((err) => {
                console.error(err);
            });
    };

    return asLink ? (
        <NwLink onClick={handleCopyClick}>
            <NwIcon icon={isCopied ? byPrefixAndName.fasl['clipboard-check'] : byPrefixAndName.fasl['clipboard']} />
            {label ? label : text}
        </NwLink>
    ) : (
        <CopyTextContainer className="copy-text-container" $fullWidth={fullWidth}>
            <div className="copy-text-container-text">
                <p>{label ? label : text}</p>
                {isCopied && (
                    <small>
                        <NwIcon icon={byPrefixAndName.fasl['check']} /> Copied!
                    </small>
                )}
            </div>
            <NwIcon
                pointer
                size="2x"
                icon={isCopied ? byPrefixAndName.fasl['clipboard-check'] : byPrefixAndName.fasl['clipboard']}
                onClick={handleCopyClick}
            />
        </CopyTextContainer>
    );
};

export default NwClipboardCopyText;
